/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vendor_select__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./vendor/select */ "./src/js/vendor/select.js");
/* harmony import */ var _snippets_static_delivery_method__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./snippets/static-delivery-method */ "./src/js/snippets/static-delivery-method.js");
/* harmony import */ var _templates_register__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./templates/register */ "./src/js/templates/register.js");
/* harmony import */ var _templates_cart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./templates/cart */ "./src/js/templates/cart.js");
/* harmony import */ var _snippets_gift_ship__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./snippets/gift-ship */ "./src/js/snippets/gift-ship.js");






if (document.querySelector('.custom-select')) {
  (0,_vendor_select__WEBPACK_IMPORTED_MODULE_0__.select)();
}

if (document.querySelector('.delivery-methods')) {
  (0,_snippets_static_delivery_method__WEBPACK_IMPORTED_MODULE_1__.deliveryMethod)();
}

if (document.querySelector('#gsMultishippingPage')) {
  new _snippets_gift_ship__WEBPACK_IMPORTED_MODULE_4__.GiftShip();
}

var initInstance = function initInstance(element) {
  if (element == 'register-template') {
    new _templates_register__WEBPACK_IMPORTED_MODULE_2__.Register();
  }

  if (element == 'cart-template') {
    new _templates_cart__WEBPACK_IMPORTED_MODULE_3__.Cart();
  }
};

var queryElement = '[init-js]';
document.querySelectorAll(queryElement).forEach(function (elem) {
  initInstance(elem.dataset.sectionType);
});

/***/ }),

/***/ "./src/js/snippets/gift-ship.js":
/*!**************************************!*\
  !*** ./src/js/snippets/gift-ship.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GiftShip": () => (/* binding */ GiftShip)
/* harmony export */ });
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/constants */ "./src/js/utils/constants.js");


var GiftShip = function GiftShip() {
  var selectors = {
    shippingGroup: (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)('.main.gs__main', true),
    fieldsetLegend: '.gs__content-box legend',
    rateBtnLabel: '.rate-toggle-label',
    ratesContainer: '.gs__shipping-rate-container',
    methodLabel: '.gs__radio-label',
    radioWrapper: '.gs__radio-wrapper',
    giftShipCheckbox: '.gs__gift-checkbox',
    checkoutBtn: '#gsMultiCheckout',
    checkoutBtnCopy: '#gsMultiCheckoutCopy',
    radioBtnContainer: '.gs__radio-input',
    rateRadioBtn: '.gs__input-radio',
    shippingData: '.gs__shipping-data',
    rateName: '.gs__shipping-name',
    fieldsetContainer: '.gs__content-box',
    calendarPicker: '.flatpickr-calendar'
  };
  var classes = {
    selected: 'selected'
  };

  function toggleRate(e) {
    var target = e.target.getAttribute('data-target');

    if (!e.target.classList.contains('loading')) {
      if ((0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)("#".concat(target)).parentNode.classList.contains('active')) {
        (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)("#".concat(target)).parentNode.classList.remove('active');
      } else {
        (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)("#".concat(target)).parentNode.classList.add('active');
      }
    }
  }

  function setInitialMethod() {
    (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.ratesContainer, true).forEach(function (e, index) {
      var rateIndex = index + 1;
      var radioWrapper = e.querySelectorAll(selectors.radioWrapper, true)[0]; //radioWrapper.querySelector('.gs__shipping-price').querySelector('strong').textContent = 'FREE';

      var rateLabel = e.parentNode.querySelector(selectors.rateBtnLabel);
      if (radioWrapper.querySelector('.gs__shipping-name')) {
        rateLabel.textContent = radioWrapper.querySelector('.gs__shipping-name').textContent;
      }
      radioWrapper.classList.add(classes.selected);
      rateLabel.classList.remove('loading');
      initEventListener();

      getRowIndex(e);

      if (e.querySelectorAll(selectors.radioWrapper)[0].classList.contains('deliver-by-date')) {
        (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)('#gsDatepickerRow'.concat(rateIndex)).style.display = 'block';
      } else {
        if (e.querySelector('.gs__radio-wrapper.deliver-by-date')) {
          e.querySelector('.gs__radio-wrapper.deliver-by-date').classList.add('show-last');
        }
        (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)('#gsDatepickerRow'.concat(rateIndex)).style.display = 'none';
      }
    });
    
    checkoutBtnClone();
  }

  function checkoutBtnClone() {
    if (document.querySelector(selectors.checkoutBtn)) {
      var buttonOrig = document.querySelector(selectors.checkoutBtn);
      var buttonCopy = buttonOrig.cloneNode(true);
      buttonOrig.classList.add('hidden');
      buttonCopy.id = 'gsMultiCheckoutCopy';
      (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.insertAfter)(buttonOrig, buttonCopy);
      setTimeout(function () {
        (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.checkoutBtnCopy).addEventListener('click', validateFields);
      }, 100);
    }
  }

  function initEventListener() {
    (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.methodLabel, true).forEach(function (el) {
      el.addEventListener('click', handleChangeMethod);
    });
    
    document.addEventListener('click', function (event) {
      (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.ratesContainer, true).forEach(function (elem) {
        var isClickInsideElement = elem.parentNode.contains(event.target);

        if (!isClickInsideElement) {
          elem.closest('.gs__content-box').classList.remove('active');
        }
      });

      (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.calendarPicker, true).forEach(function (elem) {
        var isClickInsideCalendar = elem.contains(event.target);

        if (!isClickInsideCalendar) {
          elem.classList.remove('active');
        }
      });


      const datePicker = event.target.closest('[id^="gsDatepickerRow"]');
      if (datePicker) {
        const parentContainer = datePicker.closest('.gsAppContainer');
        if (parentContainer) {
          const calendar = parentContainer.querySelector('.flatpickr-calendar');
          
          if (calendar) {
            calendar.classList.add('active');
          }
        }
      }
    });
    (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.giftShipCheckbox, true).forEach(function (checkbox) {
      checkbox.addEventListener('change', toggleGiftBox);
    });
  }

  function toggleGiftBox(e) {
    e.target.closest('.gs__group').querySelectorAll('.gsMessageContainer .has--error').forEach(function (e) {
      e.classList.remove('has--error');
      e.querySelector('.error').remove();
    });
  }

  function validateFields(e) {
    var totalErrors = 0;
    selectors.shippingGroup.forEach(function (elem, index) {
      var elementCtr = index + 1;
      var formFields = [],
          formFields = ["#from_message".concat(elementCtr), "#gsMessage".concat(elementCtr)]; // console.log(elem.querySelector(selectors.giftShipCheckbox).checked);

      if (elem.querySelector(selectors.giftShipCheckbox).checked) {
        formFields.forEach(function (field) {
          var fieldElement = (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(field);

          if (fieldElement.value === "" || fieldElement.value == null) {
            if (!fieldElement.parentNode.classList.contains('has--error')) {
              fieldElement.parentNode.classList.add('has--error');
              (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.insertAfter)(fieldElement, createErrorElement('This field is required'));
            }
          } else {
            var _fieldElement$parentN;

            fieldElement.parentNode.classList.remove('has--error');
            (_fieldElement$parentN = fieldElement.parentNode.querySelector('.error')) === null || _fieldElement$parentN === void 0 ? void 0 : _fieldElement$parentN.remove();
          }

          ;
        });
      } else {
        // errorCtr -= formFields.length;s
        // elem.querySelectorAll('.has--error').forEach(function (errorEl) {
        //   var _errorEl$querySelecto;

        //   errorEl.classList.remove('.has--error');
        //   (_errorEl$querySelecto = errorEl.querySelector('.error')) === null || _errorEl$querySelecto === void 0 ? void 0 : _errorEl$querySelecto.remove();
        // });

        formFields.forEach(function (field) {
          var fieldElement = (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(field);
          var _fieldElement$parentN;

          fieldElement.parentNode.classList.remove('has--error');
          (_fieldElement$parentN = fieldElement.parentNode.querySelector('.error')) === null || _fieldElement$parentN === void 0 ? void 0 : _fieldElement$parentN.remove();
        });
      } // if (queryElement(`#gsDatepickerRow${currentRow}`).)


      var datepickerRow = (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)("#gsDatepickerRow".concat(elementCtr));

      if (datepickerRow.offsetParent) {
        var dateField = datepickerRow.querySelector('input[type="text"]');

        if (dateField.value == "" || dateField.value == null) {
          if (!datepickerRow.classList.contains('has--error')) {
            datepickerRow.classList.add('has--error');
            (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.insertAfter)(dateField, createErrorElement('This field is required'));
          }
        } else {
          var _datepickerRow$queryS;

          datepickerRow.classList.remove('has--error');
          (_datepickerRow$queryS = datepickerRow.querySelector('.error')) === null || _datepickerRow$queryS === void 0 ? void 0 : _datepickerRow$queryS.remove();
        }
      }

      totalErrors += elem.querySelectorAll('.error').length;
    });

    console.log(totalErrors);
    
    if (totalErrors <= 0 || totalErrors == null) {
      (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.checkoutBtn).click();
    }

    return false;
  }

  function createErrorElement(message) {
    var el = document.createElement('span');
    el.textContent = message;
    el.setAttribute('class', 'error');
    return el;
  }

  function handleChangeMethod(e) {
    e.target.closest(selectors.ratesContainer).querySelectorAll(selectors.radioWrapper).forEach(function (el) {
      el.classList.remove(classes.selected);
    });
    e.target.closest(selectors.radioWrapper).classList.add(classes.selected);
    var currentRow = getRowIndex(e.target);

    console.log(e.target.closest(selectors.radioWrapper).querySelector(selectors.rateName).textContent);
    
    if (e.target.closest(selectors.radioWrapper).querySelector(selectors.rateName).textContent.indexOf('Custom Deliver-By') > -1) {
      (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)("#gsDatepickerRow".concat(currentRow)).style.display = 'block';
      // var clickEvent = new Event('click');
      // (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)("#gsDeliveryDate".concat(currentRow)).dispatchEvent(clickEvent);
    } else {
      (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)("#gsDatepickerRow".concat(currentRow)).style.display = 'none';

      var datePickerContainer = (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)("#gsDatepickerRow".concat(currentRow));
      var _datepickerRow$queryS;
      datePickerContainer.classList.remove('has--error');
      (_datepickerRow$queryS = datePickerContainer.querySelector('.error')) === null || _datepickerRow$queryS === void 0 ? void 0 : _datepickerRow$queryS.remove();
    }

    var containerEl = (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.ratesContainer, true)[currentRow - 1];
    containerEl.parentNode.querySelector('label').textContent = e.target.closest(selectors.radioWrapper).querySelector(selectors.rateName).textContent;
    containerEl.closest('.gs__content-box').classList.remove('active');
  }

  var calenDarPickrs,
      isMoveDatePickerEl = true;

  function getRowIndex(e) {
    calenDarPickrs = document.querySelectorAll('.flatpickr-calendar');
    var shippingDropdown = document.querySelectorAll('.gs__shipping-rate-container');
    // console.log(calenDarPickrs, isMoveDatePickerEl); // let rowNumber = parseInt(e.closest(selectors.ratesContainer).getAttribute('id').replace('address_index_', ''));
    // const gsSectionContent = e.parentNode.parentNode.parentNode.parentNode.parentNode;
    // if (rowNumber) {
    //   const calenDarPickrItem = calenDarPickrs[rowNumber-1];
    //   gsSectionContent.style.position = 'relative';
    //   gsSectionContent.appendChild(calenDarPickrItem)
    // }

    if (isMoveDatePickerEl) {
      for (var i = 0; i < shippingDropdown.length; i++) {
        var shippingSingleDropdown = shippingDropdown[i].parentNode.parentNode;
        let nextElement = shippingSingleDropdown.nextElementSibling;
        var gsAppContainer = nextElement?.querySelector('.gsAppContainer');
        
        if (gsAppContainer) {
          gsAppContainer.appendChild(calenDarPickrs[i]);
          gsAppContainer.style.position = 'relative';
        }

        calenDarPickrs[i].setAttribute("id", "flatpickr".concat([i+1]));
      }

      isMoveDatePickerEl = false;
    }

    return parseInt(e.closest(selectors.ratesContainer).getAttribute('id').replace('address_index_', ''));
  }

  function init() {
    var legends = (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.fieldsetLegend, true);
    legends.forEach(function (element, index) {
      var legendText = element.textContent;
      var label = document.createElement('label');
      label.setAttribute('data-target', "address_index_".concat(index + 1));
      label.setAttribute('class', "rate-toggle-label loading");
      label.textContent = legendText;
      (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.insertAfter)(element, label);
    }); // add event listener to shipping methods label

    (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.rateBtnLabel, true).forEach(function (element) {
      element.addEventListener('click', toggleRate);
    }); // force to check is gift checkbox

    (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)('.gs__toggle-feature-item', true).forEach(function (e) {
      e.classList.remove('gs__collapsed');
      e.querySelector(selectors.giftShipCheckbox).checked = true;
    });
  }

  var giftShipInterval = setInterval(inializer, 1000);

  function inializer() {
    var done = false;
    var ctr = 0;
    (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.ratesContainer, true).forEach(function (e) {
      if (e.querySelectorAll('.gs__radio-wrapper').length > 0) {
        ctr++;
      }

      if (ctr >= (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.ratesContainer, true).length) {
        setInitialMethod();
        clearInterval(giftShipInterval);
      }
    });
  }

  document.addEventListener('giftship.reloaded', function(event) {
    checkoutBtnClone();
  });

  document.addEventListener('giftship.shipping.rate-loaded', function(event) {
    const lineItemIndex = event.detail.index;
    const container = document.getElementById("address_index_"+lineItemIndex);
  
    document.addEventListener('giftship.shipping.rates-complete', function() {
      $('.gs__shipping-rate-container .gs__radio-wrapper').each(function() {
        var shippingName = $(this).find('.gs__shipping-name').text();
        if (~shippingName.indexOf("Deliver-By Date")) {
          $(this).addClass('deliver-by-date');
        }
      });
    });
  });

  init();

  document.addEventListener('giftship.reloaded', function() {
    console.log('reloaded');
    (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.rateBtnLabel, true).forEach(function (element) {
      element.removeEventListener('click', toggleRate);
      element.addEventListener('click', toggleRate);
    });

    (0,_utils_constants__WEBPACK_IMPORTED_MODULE_0__.queryElement)(selectors.ratesContainer, true).forEach(function (e) {
      e.querySelectorAll(selectors.rateRadioBtn).forEach(function (e) {
        e.closest(selectors.radioWrapper).classList.remove(classes.selected); //Remove current active state of all shipping options
        if(e.checked) {
          var radioWrapper = e.closest(selectors.radioWrapper);
          var rateLabel = e.closest(selectors.fieldsetContainer).querySelector(selectors.rateBtnLabel);
          if (radioWrapper.querySelector('.gs__shipping-name')) {
            rateLabel.textContent = radioWrapper.querySelector('.gs__shipping-name').textContent;
          }
          radioWrapper.classList.add(classes.selected);
        }
      });
    });

    initEventListener();
  });
};



/***/ }),

/***/ "./src/js/snippets/static-delivery-method.js":
/*!***************************************************!*\
  !*** ./src/js/snippets/static-delivery-method.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "deliveryMethod": () => (/* binding */ deliveryMethod)
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! js-cookie */ "../node_modules/js-cookie/dist/js.cookie.mjs");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/constants */ "./src/js/utils/constants.js");


function deliveryMethod() {
  var select = queryElement('.select-items div', true);
  var calendar = queryElement('.delivery-container');
  var calendar_input = queryElement('#delivery-date');

  function init() {
    // set initial cookie value
    js_cookie__WEBPACK_IMPORTED_MODULE_0__["default"].set(_utils_constants__WEBPACK_IMPORTED_MODULE_1__.COOKIE_DELIVERY_METHOD, select[0].innerHTML);
    select.forEach(function (e) {
      e.addEventListener('click', setDeliveryMethod.bind(e));
    });
  }

  function setDeliveryMethod(e) {
    if (e.target.innerHTML.indexOf(_utils_constants__WEBPACK_IMPORTED_MODULE_1__.METHOD_EMPTY) > -1) {
      js_cookie__WEBPACK_IMPORTED_MODULE_0__["default"].remove(_utils_constants__WEBPACK_IMPORTED_MODULE_1__.COOKIE_DELIVERY_METHOD);
      toggleCalendar('hide');
      return;
    }

    js_cookie__WEBPACK_IMPORTED_MODULE_0__["default"].set(_utils_constants__WEBPACK_IMPORTED_MODULE_1__.COOKIE_DELIVERY_METHOD, e.target.innerHTML);

    if (e.target.innerHTML.indexOf(_utils_constants__WEBPACK_IMPORTED_MODULE_1__.METHOD_CUSTOM) > -1) {
      //  check if selected method is custom delivery
      toggleCalendar('show');
      return;
    }

    toggleCalendar('hide');
  }

  function handleDateChange(e) {
    console.log('hello world', e);
  } //  
  //  element = element to query
  //  true = query multiple element
  //


  function queryElement(element, all) {
    if (all) return document.querySelectorAll(element);
    return document.querySelector(element);
  }

  function toggleCalendar(action) {
    if (action === 'hide') {
      calendar.classList.add('hidden');
      calendar_input.disabled = true;
    } else {
      calendar.classList.remove('hidden');
      calendar_input.disabled = false;
    }
  }

  init();
}

/***/ }),

/***/ "./src/js/templates/cart.js":
/*!**********************************!*\
  !*** ./src/js/templates/cart.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cart": () => (/* binding */ Cart)
/* harmony export */ });
var Cart = function Cart() {
  var isMultipleItems = function isMultipleItems() {
    if (parseInt(window.cartInfo.cart_items) > 1) return true;
    return false;
  };

  var init = function init() {
    if (isMultipleItems()) {
      window.location.href = '/a/gs/cart/';
    }
  };

  init();
};



/***/ }),

/***/ "./src/js/templates/register.js":
/*!**************************************!*\
  !*** ./src/js/templates/register.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Register": () => (/* binding */ Register)
/* harmony export */ });
var Register = function Register() {
  var selectors = {
    password: 'input#password',
    confirmPassword: 'input#retype-password',
    errorTxt: '#error-text',
    submitBtn: '#registration-form-submit',
    form: '#create_customer'
  };

  var queryElement = function queryElement(element) {
    return document.querySelector(element);
  };

  var initEventHandler = function initEventHandler() {
    queryElement(selectors.password).addEventListener('change', onChangePassword);
    queryElement(selectors.confirmPassword).addEventListener('keyup', onChangePassword);
    queryElement(selectors.form).addEventListener('submit', onSubmitForm);
  };

  var onChangePassword = function onChangePassword() {
    verifyPassword();
  };

  var onSubmitForm = function onSubmitForm(e) {
    if (verifyPassword()) {
      return true;
    } else {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  };

  var verifyPassword = function verifyPassword() {
    var password = queryElement(selectors.password).value,
        confirmPassword = queryElement(selectors.confirmPassword).value;

    if (!password) {
      queryElement(selectors.errorTxt).innerHTML = "Password is required";
      return false;
    }

    if (password.length < 8) {
      queryElement(selectors.errorTxt).innerHTML = "password must be at least 8 characters";
      return false;
    }

    if (!confirmPassword) {
      queryElement(selectors.errorTxt).innerHTML = "Confirm your password";
      return false;
    }

    if (password !== confirmPassword) {
      queryElement(selectors.errorTxt).innerHTML = "Password does not match";
      return false;
    }

    queryElement(selectors.errorTxt).innerHTML = "";
    return true;
  };

  var init = function init() {
    initEventHandler();
  };

  init();
};



/***/ }),

/***/ "./src/js/utils/constants.js":
/*!***********************************!*\
  !*** ./src/js/utils/constants.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "COOKIE_DELIVERY_METHOD": () => (/* binding */ COOKIE_DELIVERY_METHOD),
/* harmony export */   "METHOD_CUSTOM": () => (/* binding */ METHOD_CUSTOM),
/* harmony export */   "METHOD_EMPTY": () => (/* binding */ METHOD_EMPTY),
/* harmony export */   "insertAfter": () => (/* binding */ insertAfter),
/* harmony export */   "queryElement": () => (/* binding */ queryElement)
/* harmony export */ });
var COOKIE_DELIVERY_METHOD = 'delivery-method';
var METHOD_EMPTY = 'Delivery Methods';
var METHOD_CUSTOM = 'Custom Deliver';
var queryElement = function queryElement(element) {
  var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (all) {
    return document.querySelectorAll(element);
  } else {
    return document.querySelector(element);
  }
};
var insertAfter = function insertAfter(referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
};

/***/ }),

/***/ "./src/js/vendor/select.js":
/*!*********************************!*\
  !*** ./src/js/vendor/select.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "select": () => (/* binding */ select)
/* harmony export */ });
function select() {
  var x, i, j, l, ll, selElmnt, a, b, c;
  /*look for any elements with the class "custom-select":*/

  var chevronDown = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path><path d="M0-.75h24v24H0z" fill="none"></path></svg>';
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  render_xml('custom-select', chevronDown);

  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /*for each element, create a new DIV that will act as the selected item:*/

    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/

    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");

    for (j = 1; j < ll; j++) {
      /*for each option in the original select element,
      create a new DIV that will act as an option item:*/
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function (e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;

        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;

            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }

            this.setAttribute("class", "same-as-selected");
            break;
          }
        }

        h.click();
      });
      b.appendChild(c);
    }

    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }

  function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    var x,
        y,
        i,
        xl,
        yl,
        arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;

    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }

    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }

  function render_xml(id, xml_string) {
    var doc = new DOMParser().parseFromString(xml_string, 'application/xml');
    var el = document.getElementById(id);
    el.appendChild(el.ownerDocument.importNode(doc.documentElement, true));
  }
  /*if the user clicks anywhere outside the select box,
  then close all select boxes:*/


  document.addEventListener("click", closeAllSelect);
}

/***/ }),

/***/ "./src/scss/theme.scss":
/*!*****************************!*\
  !*** ./src/scss/theme.scss ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/checkout.scss":
/*!********************************!*\
  !*** ./src/scss/checkout.scss ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "../node_modules/js-cookie/dist/js.cookie.mjs":
/*!****************************************************!*\
  !*** ../node_modules/js-cookie/dist/js.cookie.mjs ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (api);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/theme": 0,
/******/ 			"assets/checkout": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkthefruitcompany_shopify"] = self["webpackChunkthefruitcompany_shopify"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/theme","assets/checkout"], () => (__webpack_require__("./src/js/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/theme","assets/checkout"], () => (__webpack_require__("./src/scss/theme.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/theme","assets/checkout"], () => (__webpack_require__("./src/scss/checkout.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;